import * as Styled from "./Chip.styled"

export function ChipSkeleton(props) {
    return <Styled.ChipSkeleton variant="circular" {...props} />
}